import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    section1: {
      inputType: 'section',
      title: 'Assistant in Resources',
      span: 'full',
    },
    assistantInResources: {
      inputType: 'FileTable',
      title: 'Assistant in Resources',
      filePath: 'configuration/assistant-in-resources',
      required: true,
      span: 'full',
      showStatus: false,
      showCategory: false,
      canDelete: true,
      multiple: true,
    },
  }
}
